import './App.css';

import React, {
  useEffect,
  useState,
} from 'react';

import {
  differenceInCalendarDays,
  format,
} from 'date-fns';
import { es } from 'date-fns/locale';
import { createBrowserHistory } from 'history';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  Redirect,
  Route,
  Router,
  Switch,
} from 'react-router-dom';

import {
  getCities,
  getDocumentTypesAction,
  getFrequentQuestions,
  getMenusAction,
  getRegimeTypesAction,
  getRetiresTypesAction,
  getStatesAction,
} from './actions/configAction';
import { getBasicPlanAvailability } from './actions/dashboardAction';
import {
  AdjustmentManage,
} from './components/_PayrollAdjustment/adjustmentManage';
import ResponseModal from './components/modal/responseModal.component';
import {
  CHATBOT_WOLKVOX,
  LICENSE_SHOP_URL,
} from './config/config';
import { getCompanyId } from './helpers/getCompanyId';
import { readError } from './helpers/readError';
import { usePayroll } from './hooks/usePayroll';
import useLicenceRedirect from './hooks/useTokenRedirect';
import PrivateRoute from './routes/privateRoutes';
import PublicRoute from './routes/publicRoutes';
import {
  selectDashboardLicense,
} from './selector/dashboard/licenseReferenceSelector';
import { Home } from './views/dashboard/home.view';
import EmployeesView from './views/employees';
import Help from './views/helps/help.view';
import Index from './views/home/index';
import licencesView from './views/licences/licences';
import MyAccount from './views/myAccount';
import PayrollView from './views/payroll';
import ReportsView from './views/reports/ReportsView';

let hist = createBrowserHistory();

const initialModal = {
  modalType: '',
  title: '',
  subtitle: '',
  body: '',
  modalImage: '',
  open: false,
  closeElement: '',
};

export const Startup = () => {
  const [ModalResponse, setModalResponse] = useState(initialModal);
  const [ModalResponseDays, setModalResponseDays] = useState(initialModal);
  const { getRedirectUrl } = useLicenceRedirect();

  const dispatch = useDispatch();
  const companyId = getCompanyId();

  const { currentError } = useSelector(s => s.generalReducer);
  const { counterData } = useSelector(selectDashboardLicense);

  const fechaExpiracionLicenciaEmp = new Date(
    counterData?.fechaExpiracionLicenciaEmp
  );
  const fechaExpiracionLicenciaDoc = new Date(
    counterData?.fechaExpiracionLicenciaDoc
  );
  const licEmp = counterData?.licenciaActivaEmp;
  const LicDoc = counterData?.licenciaActivaDoc;

  const basePlanExpired = {
    modalType: 'warning',
    title: 'Tu plan de Colfactura nómina venció',
    body: (
      <div>
        <p
          style={{
            fontWeight: 700,
            fontSize: 25,
          }}
        >
          {`No cuentas con un plan activo, es necesario renovarlo para que puedas seguir transmitiendo nóminas.`}
        </p>
        <p
          style={{
            marginTop: 10,
            fontWeight: 700,
            fontSize: 25,
          }}
        >
          {'Si quieres comprar tu nuevo plan, haz clic en Comprar'}
        </p>
      </div>
    ),
    modalImage: 'warning',
    open: true,
    textButton: 'Comprar',
    closeElement: 'Skip',
    urlButton: getRedirectUrl('') || LICENSE_SHOP_URL,
  };

  // custom hook
  const { fillCurrentStateTransmision } = usePayroll();

  /**
   * Cargue Inicial
   */
  useEffect(() => {
    dispatch(getMenusAction());
    dispatch(getStatesAction());
    dispatch(getCities());
    dispatch(getRegimeTypesAction());
    dispatch(getDocumentTypesAction());
    dispatch(getRetiresTypesAction());
    dispatch(getFrequentQuestions());

    //Se inicializa el Chatbot de ayuda
    const script = document.createElement('script');
    script.id = 'prodId';
    script.type = 'text/javascript';
    script.src = CHATBOT_WOLKVOX;
    script.async = '';
    document.body.appendChild(script);

    fillCurrentStateTransmision();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (companyId) {
      dispatch(getBasicPlanAvailability());
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    if (!!currentError?.error) {
      readError(currentError);
    }
  }, [currentError]);

  useEffect(() => {
    if (!counterData) return;

    const differenceInCalendarDayEmp = differenceInCalendarDays(
      fechaExpiracionLicenciaEmp,
      new Date()
    );
    const differenceInCalendarDayDoc = differenceInCalendarDays(
      fechaExpiracionLicenciaDoc,
      new Date()
    );

    const areBothLicensesExpired =
      !licEmp &&
      counterData.fechaExpiracionLicenciaEmp !== null &&
      !LicDoc &&
      counterData.fechaExpiracionLicenciaDoc !== null;

    if (areBothLicensesExpired) {
      setModalResponse(basePlanExpired);
      return;
    }

    const isDocumentLicenseAboutToExpire =
      differenceInCalendarDayDoc <= 3 && differenceInCalendarDayDoc > 0;

    const isEmployeeLicenseAboutToExpire =
      differenceInCalendarDayEmp <= 3 && differenceInCalendarDayEmp > 0;

    const createWarningModalContent = (
      daysRemaining,
      expirationDate,
      licenseType
    ) => ({
      modalType: 'warning',
      title: `Tu plan de Colfactura nómina se vence en ${daysRemaining} días`,
      body: (
        <div>
          <p
            style={{
              fontWeight: 700,
              fontSize: 25,
            }}
          >
            {`El plan que adquiriste (${licenseType}) vence el ${format(
              expirationDate,
              'dd/MMM/yyyy',
              { locale: es }
            )}`}
          </p>
          <p
            style={{
              marginTop: 10,
              fontWeight: 700,
              fontSize: 25,
            }}
          >
            {
              'Es necesario renovarlo para que puedas seguir transmitiendo nóminas. Si quieres comprar tu nuevo plan, haz clic en "Comprar".'
            }
          </p>
        </div>
      ),
      modalImage: 'warning',
      open: true,
      textButton: 'Comprar',
      closeElement: 'Skip',
      urlButton: getRedirectUrl('') || LICENSE_SHOP_URL,
    });

    if (isDocumentLicenseAboutToExpire) {
      setModalResponseDays(
        createWarningModalContent(
          differenceInCalendarDayDoc,
          fechaExpiracionLicenciaDoc,
          'Documento'
        )
      );
    } else if (isEmployeeLicenseAboutToExpire) {
      setModalResponseDays(
        createWarningModalContent(
          differenceInCalendarDayEmp,
          fechaExpiracionLicenciaEmp,
          'Empleado'
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counterData]);

  const handleCloseResponseModal = () => {
    setModalResponse(initialModal);
  };
  const handleCloseResponseModalDays = () => {
    setModalResponseDays(initialModal);
  };

  return (
    <>
      <Router history={hist}>
        <Switch>
          <PrivateRoute
            exact
            path="/dashboard"
            component={Home}
            history={hist}
            menuid={0}
          />
          <PrivateRoute
            exact
            path="/myAccount"
            component={MyAccount}
            history={hist}
            menuid={1}
          />
          <PrivateRoute
            exact
            path="/payroll"
            component={PayrollView}
            history={hist}
            menuid={2}
          />
          <PrivateRoute
            exact
            path="/employee"
            component={EmployeesView}
            history={hist}
            menuid={3}
          />
          <PrivateRoute
            exact
            path="/informes"
            component={ReportsView}
            history={hist}
            menuid={8}
          />
          <PrivateRoute
            exact
            path="/licences"
            component={licencesView}
            history={hist}
            menuid={9}
          />
          <PrivateRoute
            exact
            path="/helps"
            component={Help}
            history={hist}
            menuid={4}
          />
          <PrivateRoute
            exact
            path="/payrollAdjustment"
            component={AdjustmentManage}
            history={hist}
            menuid={10}
          />
          <PublicRoute
            exact
            path="/home/:queryString"
            component={Index}
            history={hist}
          />
          <Route render={() => <Redirect to="/dashboard" />} />
        </Switch>
      </Router>
      <ResponseModal
        modalType={ModalResponse.modalType}
        title={ModalResponse.title}
        body={ModalResponse.body}
        modalImage={ModalResponse.modalImage}
        open={ModalResponse.open}
        textButton={ModalResponse?.textButton}
        urlButton={ModalResponse?.urlButton}
        closeElement={ModalResponse.closeElement}
        onCloseElement={handleCloseResponseModal}
      />
      <ResponseModal
        modalType={ModalResponseDays.modalType}
        title={ModalResponseDays.title}
        body={ModalResponseDays.body}
        modalImage={ModalResponseDays.modalImage}
        open={ModalResponseDays.open}
        textButton={ModalResponseDays?.textButton}
        urlButton={ModalResponseDays?.urlButton}
        closeElement={ModalResponseDays.closeElement}
        onCloseElement={handleCloseResponseModalDays}
      />
    </>
  );
};
export default Startup;
